<template>
  <div class="animated fadeIn">
    <div class="form-group row">
      <div class="col-md-8">
        <Forms
          ref="frmGroup"
          :title="'NOVA IMPORTAÇÃO'"
          :showClearButton="true"
          :showSaveButton="this.files && this.files.length > 0"
          :showBackButton="true"
          v-on:Clear="onClear"
          v-on:Back="onBack"
          v-on:Save="onSave"
        >
          <!-- box de importar arquivo -->
          <div class="form-group row pb-2">
            <div class="col-md-12">
              <label for="txtDescription"> Importar Arquivos:</label>
              <div
                draggable="true"
                @drop.prevent="onDrop"
                @dragover.prevent
                class="block-upload"
                @click="addFiles()"
              >
                <div class="text-center pt-5 pb-5">
                  <i
                    style="
                      display: block;
                      font-size: 1.5rem;
                      margin-bottom: 0.5rem;
                    "
                    class="fas fa-file-import"
                  ></i>
                  Clique ou arraste e solte os arquivos aqui
                </div>
              </div>
              <div style="display: none">
                <input
                  type="file"
                  ref="planilhas"
                  multiple
                  @change="handleFilesUpload()"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/excel, text/csv"
                />
              </div>
            </div>
          </div>

          <!-- informativa de arquivos adicionados -->
          <div class="form-group row pt-3 pb-3">
            <div
              v-if="this.files && this.files.length > 0"
              class="col-md-12"
            >
              <h5 class="text-third">
                <i class="fas fa-file-import"></i> Arquivos enviados
              </h5>
              <small class="pl-2">
                Clique em gravar para iniciar a importação
              </small>
            </div>

            <div
              v-else
              class="col-md-12"
            >
              <h5 class="text-third">
                <i class="fas fa-file-import"></i> Nenhum arquivo para
                importação
              </h5>
            </div>
          </div>

          <div
            class="form-group row"
            v-for="(file, index) in importFiles"
            :key="index"
          >
            <!-- planilha -->
            <div class="col-md-4">
              <label for="txtName">
                <small class="text-danger">*</small> Arquivo:
              </label>
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="far fa-file-excel text-third"></i>
                </span>
                <b-form-input
                  type="text"
                  :placeholder="'Dados sobre o arquivos'"
                  v-model="file.name"
                  style="height: calc(1.5em + 0.75rem + 4px)"
                  :size="form.fileDetails.maxlength"
                  :required="form.fileDetails.required"
                  :state="form.fileDetails.state"
                ></b-form-input>
                <span class="input-group-addon">{{
                  bytesToSize(file.size)
                }}</span>
              </div>
            </div>

            <!-- select de tipo de planilha -->
            <div class="col-md-6 col-9">
              <label for="txtName">
                <small class="text-danger">*</small> Tipo:
              </label>
              <div class="input-group">
                <b-form-select
                  v-model="tipoPlanilha[index]"
                  :options="form.tipoPlanilha.options"
                  class="mb-3"
                  @change="changeTipoPlanilha"
                >
                  <template slot="first">
                    <option :value="null">
                      {{ $lang.Common.PlaceholderSelect }}
                    </option>
                    <option value="AJUIZAMENTO">
                      AJUIZAMENTO
                    </option>
                    <option value="ANOTACOESNEGATIVAS">
                      ANOTAÇÕES NEGATIVAS
                    </option>
                    <option value="ASSOCIADOS">ASSOCIADOS</option>
                    <option value="BENSASSOCIADOS">BENS ASSOCIADO</option>
                    <option value="CAPTACAOREMUNERADADIARIA">
                      CAPTAÇÃO REMUNERADA DIÁRIA
                    </option>
                    <option value="CARDCOOPERADO">CARD DE COOPERADOS</option>
                    <option value="CARDNAOCOOPERADO">
                      CARD DE NÃO COOPERADOS
                    </option>
                    <option value="CARTAODECREDITO">CARTÃO DE CRÉDITO</option>
                    <option value="CONSORCIO">CARTEIRA CONSÓRCIO</option>
                    <option value="SEGURO">CARTEIRA SEGUROS</option>
                    <option value="COBRANCACARTAO">COBRANÇA CARTÃO</option>
                    <option value="COBRANCAEMPRESTIMO">
                      COBRANÇA EMPRÉSTIMO
                    </option>
                    <option value="COBRANCAGERAIS">COBRANÇA GERAIS</option>
                    <option value="CONTACAPITAL">CONTA CAPITAL</option>
                    <option value="CONTACORRENTE">CONTA CORRENTE</option>
                    <option value="POUPANCA">CONTA POUPANÇA</option>
                    <option value="CONTRATOSVIGENTES">
                      CONTRATOS VIGENTES
                    </option>
                    <!--<option value="CHEQUE">CHEQUE</option>-->
                    <option value="EMAILCORPORATIVO">E-MAIL CORPORATIVO</option>
                    <option value="ENDIVIDAMENTO_SICOOB">
                      ENDIVIDAMENTO SICOOB
                    </option>
                    <option value="ENDIVIDAMENTO_SFN">ENDIVIDAMENTO SFN</option>
                    <option value="FUNCIONARIOS">FUNCIONÁRIOS</option>
                    <option value="GARANTIADEOPERACOES">
                      GARANTIA DE OPERAÇÕES
                    </option>
                    <option value="GRUPOECONOMICO">GRUPO ECONÔMICO</option>
                    <option value="IAP">IAP</option>
                    <option value="MARGEMCONTRIBUICAO">
                      MARGEM CONTRIBUIÇÃO
                    </option>
                    <option
                      v-if="hasBillingImportation"
                      value="METASPRODUCAO"
                    >
                      METAS PRODUCAO
                    </option>
                    <option
                      v-if="hasBillingImportation"
                      value="METASESBOCO"
                    >
                      METAS ESBOCO
                    </option>
                    <option value="MOVIMENTACAODIARIACONTA">
                      MOVIMENTAÇÃO DIARIA CONTA
                    </option>
                    <option value="PAGAMENTOPARCELA">PAGAMENTO PARCELA</option>
                    <option value="PIX">PIX</option>
                    <option value="PLD">PLD</option>
                    <option value="RELACIONAMENTOASSOCIADO">
                      RELACIONAMENTO ASSOCIADOS
                    </option>
                    <option value="RISCO">RISCO</option>
                    <option value="SALDOMEDIOCAPTACAO">
                      SALDO MÉDIO CAPTAÇÃO
                    </option>
                    <option value="SALDOMEDIOCCO">SALDO MÉDIO CCO</option>
                  </template>
                </b-form-select>
              </div>
            </div>

            <!-- campos de ASSOCIADOS -->
            <div
              v-if="tipoPlanilha[index] === 'ASSOCIADOS'"
              class="col-2"
            >
              <label for="txtName">Sobrepor Dados:</label>
              <div class="input-group">
                <b-form-checkbox
                  v-model="sobrescreverDados"
                  :name="'checkbox' + index"
                  :id="'checkbox' + index"
                >
                </b-form-checkbox>
              </div>
            </div>

            <!-- campos de COBRANCAEMPRESTIMO -->
            <div
              v-if="tipoPlanilha[index] === 'COBRANCAEMPRESTIMO'"
              class="col-md-12 row"
            >
              <div class="col-md-6">
                <label for="txtName">Board:</label>
                <div class="input-group">
                  <b-form-select
                    v-model="form.tipoBoardCobrancaEmprestimo.value"
                    :options="form.tipoBoardCobrancaEmprestimo.options"
                    :required="form.tipoBoardCobrancaEmprestimo.required"
                    :state="form.tipoBoardCobrancaEmprestimo.state"
                    class="mb-3"
                    v-on:change="
                      onLoadColumns(
                        form.colunaCobrancaEmprestimo,
                        form.tipoBoardCobrancaEmprestimo.value
                      )
                    "
                  >
                    <template slot="first">
                      <option :value="null">
                        {{ $lang.Common.PlaceholderSelect }}
                      </option>
                    </template>
                  </b-form-select>
                </div>
              </div>

              <div class="col-md-6">
                <label for="txtName">Coluna:</label>
                <div class="input-group">
                  <b-form-select
                    v-model="form.colunaCobrancaEmprestimo.value"
                    :options="form.colunaCobrancaEmprestimo.options"
                    :required="form.colunaCobrancaEmprestimo.required"
                    :state="form.colunaCobrancaEmprestimo.state"
                    class="mb-3"
                  >
                    <template slot="first">
                      <option :value="null">
                        {{ $lang.Common.PlaceholderSelect }}
                      </option>
                    </template>
                  </b-form-select>
                </div>
              </div>
            </div>

            <!-- campos de COBRANCACARTAO -->
            <div
              v-if="tipoPlanilha[index] === 'COBRANCACARTAO'"
              class="col-md-12 row"
            >
              <div class="col-md-6">
                <label for="txtName">Board:</label>
                <div class="input-group">
                  <b-form-select
                    v-model="form.tipoBoardCobrancaCartao.value"
                    :options="form.tipoBoardCobrancaCartao.options"
                    :required="form.tipoBoardCobrancaCartao.required"
                    :state="form.tipoBoardCobrancaCartao.state"
                    class="mb-3"
                    @change="
                      onLoadColumns(
                        form.colunaCobrancaCartao,
                        form.tipoBoardCobrancaCartao.value
                      )
                    "
                  >
                    <template slot="first">
                      <option :value="null">
                        {{ $lang.Common.PlaceholderSelect }}
                      </option>
                    </template>
                  </b-form-select>
                </div>
              </div>

              <div class="col-md-6">
                <label for="txtName">Coluna:</label>
                <div class="input-group">
                  <b-form-select
                    v-model="form.colunaCobrancaCartao.value"
                    :options="form.colunaCobrancaCartao.options"
                    :required="form.colunaCobrancaCartao.required"
                    :state="form.colunaCobrancaCartao.state"
                    class="mb-3"
                    @click="onLoadBoardsCobranca"
                  >
                    <template slot="first">
                      <option :value="null">
                        {{ $lang.Common.PlaceholderSelect }}
                      </option>
                    </template>
                  </b-form-select>
                </div>
              </div>
            </div>

            <!-- campos de AJUIZAMENTO -->
            <div
              v-if="tipoPlanilha[index] === 'AJUIZAMENTO'"
              class="col-md-12 row"
            >
              <div class="col-md-6">
                <label for="txtName">Board:</label>
                <div class="input-group">
                  <b-form-select
                    v-model="form.tipoBoardAjuizamento.value"
                    :options="form.tipoBoardAjuizamento.options"
                    :required="form.tipoBoardAjuizamento.required"
                    :state="form.tipoBoardAjuizamento.state"
                    class="mb-3"
                    @change="
                      onLoadColumns(
                        form.colunaAjuizamento,
                        form.tipoBoardAjuizamento.value
                      )
                    "
                  >
                    <template slot="first">
                      <option :value="null">
                        {{ $lang.Common.PlaceholderSelect }}
                      </option>
                    </template>
                  </b-form-select>
                </div>
              </div>

              <div class="col-md-6">
                <label for="txtName">Coluna:</label>
                <div class="input-group">
                  <b-form-select
                    v-model="form.colunaAjuizamento.value"
                    :options="form.colunaAjuizamento.options"
                    :required="form.colunaAjuizamento.required"
                    :state="form.colunaAjuizamento.state"
                    class="mb-3"
                    @click="onLoadBoardsAjuizamento"
                  >
                    <template slot="first">
                      <option :value="null">
                        {{ $lang.Common.PlaceholderSelect }}
                      </option>
                    </template>
                  </b-form-select>
                </div>
              </div>
            </div>

            <!-- campos de COBRANCAGERAIS -->
            <div
              v-if="tipoPlanilha[index] === 'COBRANCAGERAIS'"
              class="col-md-12 row"
            >
              <div class="col-md-6">
                <label for="txtName">Board:</label>
                <div class="input-group">
                  <b-form-select
                    v-model="form.tipoBoardCobrancaGerais.value"
                    :options="form.tipoBoardCobrancaGerais.options"
                    :required="form.tipoBoardCobrancaGerais.required"
                    :state="form.tipoBoardCobrancaGerais.state"
                    class="mb-3"
                    @change="
                      onLoadColumns(
                        form.colunaCobrancaGerais,
                        form.tipoBoardCobrancaGerais.value
                      )
                    "
                  >
                    <template slot="first">
                      <option :value="null">
                        {{ $lang.Common.PlaceholderSelect }}
                      </option>
                    </template>
                  </b-form-select>
                </div>
              </div>

              <div class="col-md-6">
                <label for="txtName">Coluna:</label>
                <div class="input-group">
                  <b-form-select
                    v-model="form.colunaCobrancaGerais.value"
                    :options="form.colunaCobrancaGerais.options"
                    :required="form.colunaCobrancaGerais.required"
                    :state="form.colunaCobrancaGerais.state"
                    class="mb-3"
                    @click="onLoadBoardsCobranca"
                  >
                    <template slot="first">
                      <option :value="null">
                        {{ $lang.Common.PlaceholderSelect }}
                      </option>
                    </template>
                  </b-form-select>
                </div>
              </div>
            </div>

            <!-- campos de CARDCOOPERADO e CARDNAOCOOPERADO -->
            <div
              v-if="
                tipoPlanilha[index] === 'CARDCOOPERADO' ||
                tipoPlanilha[index] === 'CARDNAOCOOPERADO'
              "
              class="col-md-12"
            >
              <div class="form-group row">
                <div class="col-md-4">
                  <label for="txtName">Origem:</label>
                  <div class="input-group">
                    <b-form-select
                      v-model="form.origemImportCards.value"
                      :options="form.origemImportCards.options"
                      :required="form.origemImportCards.required"
                      :state="form.origemImportCards.state"
                      class="mb-3"
                    >
                      <template slot="first">
                        <option :value="null">
                          {{ $lang.Common.PlaceholderSelect }}
                        </option>
                      </template>
                    </b-form-select>
                  </div>
                </div>

                <div class="col-md-4">
                  <label for="txtName">Board:</label>
                  <div class="input-group">
                    <b-form-select
                      v-model="form.boardImportCards.value"
                      :options="form.boardImportCards.options"
                      :required="form.boardImportCards.required"
                      :state="form.boardImportCards.state"
                      class="mb-3"
                      @change="
                        onLoadColumns(
                          form.columnImportCards,
                          form.boardImportCards.value
                        )
                      "
                    >
                      <template slot="first">
                        <option :value="null">
                          {{ $lang.Common.PlaceholderSelect }}
                        </option>
                      </template>
                    </b-form-select>
                  </div>
                </div>

                <div class="col-md-4">
                  <label for="txtName">Coluna:</label>
                  <div class="input-group">
                    <b-form-select
                      v-model="form.columnImportCards.value"
                      :options="form.columnImportCards.options"
                      :required="form.columnImportCards.required"
                      :state="form.columnImportCards.state"
                      class="mb-3"
                      @click="onLoadBoards"
                    >
                      <template slot="first">
                        <option :value="null">
                          {{ $lang.Common.PlaceholderSelect }}
                        </option>
                      </template>
                    </b-form-select>
                  </div>
                </div>
              </div>

              <div>
                <div class="form-group">
                  <div class="input-group">
                    <b-form-checkbox
                      id="vincularGerenteCard"
                      name="vincularGerenteCard"
                      v-model="form.vincularGerenteAoCard.value"
                    >
                      Vincular Gerente ao Card?
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-if="tipoPlanilha[index] === 'CARDCOOPERADO'"
                      id="vincularGerenteRelacionamento"
                      name="vincularGerenteRelacionamento"
                      v-model="form.vincularGerenteRelacionamento.value"
                    >
                      Vincular Gerente de Relacionamento?
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-if="tipoPlanilha[index] === 'CARDCOOPERADO'"
                      id="atualizarClusterizacao"
                      name="atualizarClusterizacao"
                      v-model="form.atualizarClusterizacao.value"
                    >
                      Atualizar Clusterização?
                    </b-form-checkbox>
                    <b-form-checkbox
                      id="atualizarResponsaveis"
                      name="atualizarResponsaveis"
                      v-model="form.atualizarResponsaveis.value"
                    >
                      Atualizar Responsáveis de Todas Oportunidades Ativas?
                    </b-form-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Forms>
      </div>

      <!-- download templates de exemplo -->
      <div class="col-md-4">
        <b-card
          title="MODELO DE ARQUIVOS"
          sub-title="Modelo de arquivos para importação"
        >
          <b-card-text>
            <ul>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/Ajuizamentos.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Ajuizamento
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/Anotacoes-Negativas.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Anotações
                  Negativas
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/v4/Associados.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Associado
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/v2/Bens-Associado.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Bens Associado
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/Investimentos.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Captação
                  Remunerada Diária
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/GerarCardsAssociados.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Gerar Cards de
                  Cooperados
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/GerarCardsNaoAssociados.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Gerar Cards de
                  Não Cooperados
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/Cartao-de-Credito.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Cartão de
                  Crédito
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/Carteira-Consorcio.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Carteira
                  Consórcio
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/Carteira-Seguros.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Carteira Seguros
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/cobranca_cartao.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Cobrança Cartão
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/cobranca_emprestimo.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Cobrança
                  Empréstimo
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/cobranca_geral.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Cobrança Geral
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/v2/Conta-Capital.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Conta Capital
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/Conta-Corrente.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Conta Corrente
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/v2/Conta-Poupanca.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Conta Poupança
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/v3/Contratos-Vigentes.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Contratos
                  Vigentes
                </a>
              </li>
              <li v-if="false">
                <a
                  href="https://static.nexum.com.br/template/planilhas/Cheque.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Cheque
                </a>
              </li>
              <!-- <li>
                NOT BEING USED BECAUSE HAVE BEEN SPLIT INTO 2
                <a href="https://static.nexum.com.br/template/planilhas/Endividamento.xlsx" target="_blank">
                  <i class="fas fa-file-excel excel-color"></i> Endividamento
                </a>
              </li> -->
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/email-corporativo.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> E-mail
                  Corporativo
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/v2/Endividamento_Sicoob.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Endividamento
                  Sicoob
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/v2/ENDIVIDAMENTO_SFN.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Endividamento
                  SFN
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/Funcionarios.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Funcionários
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/Garantia-de-Operacoes.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Garantia de
                  Operações
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/Grupo-Economico.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Grupo Econômico
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/v2/IAP-Mensal.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> IAP
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/v2/Margem-Contriibuicao.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Margem
                  Contribuição
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/Movimentacao-Diaria-Conta.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Movimentação
                  Diária Conta
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/Pagamento-Parcela.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Pagamento
                  Parcela
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/pix.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> PIX
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/RELACIONAMENTO-ASSOCIADOS.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Relacionamento
                  Associados
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/RISCO-ASSOCIADO.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Risco
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/Saldo-Medio-Captacao.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Saldo Médio
                  Captação
                </a>
              </li>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/v2/Saldo-Medio-CCO.xlsx"
                  target="_blank"
                >
                  <i class="fas fa-file-excel excel-color"></i> Saldo Médio CCO
                </a>
              </li>
            </ul>
          </b-card-text>
          <b-card-text class="pt-4 pb-4 text-center">
            <small> Clique no arquivo para fazer o download! </small>
          </b-card-text>
        </b-card>
      </div>
    </div>
    <div v-if="hasWaitUpload">
      <div class="upload"></div>
      <div class="uploadText">
        <h2>
          <i class="fas fa-file-import"></i> Upload iniciado! <br />Aguarde um
          momento, por favor.<br />
          <small style="font-size: 12px; padding-top: 10px"
            >Essa mensagem será fechado ao final!</small
          >
        </h2>
      </div>
      <div class="upload-loading">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          class="upload-loading-img"
          width="200px"
          height="200px"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
        >
          <g transform="translate(20 50)">
            <circle
              cx="0"
              cy="0"
              r="6"
              fill="#006a5b"
            >
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="-0.375s"
                calcMode="spline"
                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                values="0;1;0"
                keyTimes="0;0.5;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
          </g>
          <g transform="translate(40 50)">
            <circle
              cx="0"
              cy="0"
              r="6"
              fill="#04a791"
            >
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="-0.25s"
                calcMode="spline"
                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                values="0;1;0"
                keyTimes="0;0.5;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
          </g>
          <g transform="translate(60 50)">
            <circle
              cx="0"
              cy="0"
              r="6"
              fill="#abbd81"
            >
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="-0.125s"
                calcMode="spline"
                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                values="0;1;0"
                keyTimes="0;0.5;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
          </g>
          <g transform="translate(80 50)">
            <circle
              cx="0"
              cy="0"
              r="6"
              fill="#d1ddb5"
            >
              <animateTransform
                attributeName="transform"
                type="scale"
                begin="0s"
                calcMode="spline"
                keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                values="0;1;0"
                keyTimes="0;0.5;1"
                dur="1s"
                repeatCount="indefinite"
              ></animateTransform>
            </circle>
          </g>
        </svg>
        <div class="text-center">
          <strong>Acompanhe abaixo o envio dos arquivos:</strong>
          <ul
            class="pt-3"
            v-for="(obj, index) in uploadingFiles"
            :key="index"
          >
            <li
              v-if="obj.uploaded"
              class="pt-2"
            >
              <i class="far fa-file-excel excel-color"></i> {{ obj.file.name }}
              <i class="fas fa-check excel-color"></i>
            </li>
            <li
              v-else
              class="pt-2"
            >
              <i class="fas fa-upload text-third"></i> Enviando
              {{ obj.file.name }}
              <b-spinner
                small
                label="Aguarde..."
                variant="success"
              ></b-spinner>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import ImportsForms from './import-form.js'

import ImportsRepository from '@/shared/http/repositories/configurations/imports.js'
import OriginRepository from '@/shared/http/repositories/configurations/origin.js'
import BoardRepository from '@/shared/http/repositories/crm/board.js'
import BoardColumnRepository from '@/shared/http/repositories/crm/boardcolumn.js'

const ImportData = {
  id: null,
  responsavel: null,
  tipoPlanilha: null
}

export default {
  name: 'AccountAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: ImportData,
      form: ImportsForms,
      sobrescreverDados: null,
      files: [],
      tipoPlanilha: [],
      waitUpload: false,
      uploadingFiles: [],
      hasBillingImportation: process.env.hasBillingImportation
    }
  },
  computed: {
    importFiles () {
      var result = []
      if (this.files && this.files.length > 0) {
        result = this.files
      }
      return result
    },
    hasWaitUpload () {
      return this.waitUpload
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      if (this.$refs.alert) {
        this.$refs.alert.Close()
      }
      this.files = []
      this.form.tipoPlanilha.value = []
    },
    async onLoad () {
      await this.onLoadOrigem()
      await this.onLoadBoardsCobranca()
      await this.onLoadBoardsAjuizamento()
      await this.onLoadBoards()
    },
    async onCreate () {
      if (!this.files || !this.tipoPlanilha || this.tipoPlanilha.length === 0) {
        toast.warning(
          'ATENÇÃO! Não há arquivos para importação ou não foi definido o tipo',
          'IMPORTAÇÃO'
        )
      }

      this.uploadingFiles = []
      const dataSend = this.sortData(this.files)
      this.waitUpload = true
      let pointer = 0

      for await (let obj of dataSend) {
        let formData = new FormData()
        let importData = this.buildImportData(obj)

        if (importData.tipoPlanilha) {
          const json = new Blob([JSON.stringify(importData)], {
            type: 'application/json'
          })
          formData.append('file', obj.file)
          formData.append('data', json)

          this.uploadingFiles.push({
            id: pointer,
            file: obj.file,
            data: importData,
            uploaded: false
          })

          try {
            await ImportsRepository.Create(formData)
            this.uploadingFiles[pointer].uploaded = true
            pointer++
          } catch (error) {
            this.onException(error)
          }
        } else {
          toast.warning(
            `ATENÇÃO! Informe o Tipo para importar o arquivo ${obj.file.name}`,
            'IMPORTAÇÃO'
          )
        }
      }

      this.waitUpload = false
      this.$emit('Back')
    },
    sortData (files) {
      let sortedFiles = []
      let index = 0

      if (!this.tipoPlanilha) {
        toast.warning(
          'ATENÇÃO! Você precisa informar o Tipo para realizar a importação o arquivo!',
          'IMPORTAÇÃO - TIPO NÃO INFORMADO!'
        )
        loading.close()
        return false
      }

      for (const file of files) {
        const tipoPlanilha = this.tipoPlanilha[index]
        if (!tipoPlanilha) {
          toast.warning(
            `ATENÇÃO! Informe o Tipo para o arquivo ${file.name}`,
            'IMPORTAÇÃO'
          )
          loading.close()
          return false
        }

        sortedFiles.push({ tipoPlanilha: tipoPlanilha, file })
        index++
      }

      return sortedFiles
    },
    buildImportData (obj) {
      const tipoPlanilha = obj.tipoPlanilha

      return {
        id: null,
        responsavel: null,
        tipoPlanilha,
        sobrescreverDados: this.sobrescreverDados,
        origemLeadId: this.getOrigemId(tipoPlanilha),
        boardId: this.getBoardId(tipoPlanilha),
        boardColumnId: this.getBoardColumnId(tipoPlanilha),
        vincularGerenteAoCard: this.form.vincularGerenteAoCard.value,
        vincularGerenteRelacionamento:
          this.form.vincularGerenteRelacionamento.value,
        atualizarClusterizacao: this.form.atualizarClusterizacao.value,
        atualizarResponsaveis: this.form.atualizarResponsaveis.value
      }
    },
    getOrigemId (tipoPlanilha) {
      if (
        tipoPlanilha === 'CARDCOOPERADO' ||
        tipoPlanilha === 'CARDNAOCOOPERADO'
      ) {
        return this.form.origemImportCards.value
      }

      return null
    },
    getBoardId (tipoPlanilha) {
      if (tipoPlanilha === 'COBRANCAEMPRESTIMO') {
        return this.form.tipoBoardCobrancaEmprestimo.value
      }
      if (tipoPlanilha === 'COBRANCACARTAO') {
        return this.form.tipoBoardCobrancaCartao.value
      }
      if (tipoPlanilha === 'COBRANCAGERAIS') {
        return this.form.tipoBoardCobrancaGerais.value
      }
      if (tipoPlanilha === 'AJUIZAMENTO') {
        return this.form.tipoBoardAjuizamento.value
      }

      if (
        tipoPlanilha === 'CARDCOOPERADO' ||
        tipoPlanilha === 'CARDNAOCOOPERADO'
      ) {
        return this.form.boardImportCards.value
      }

      return null
    },
    getBoardColumnId (tipoPlanilha) {
      if (tipoPlanilha === 'COBRANCAEMPRESTIMO') {
        return this.form.colunaCobrancaEmprestimo.value
      }
      if (tipoPlanilha === 'COBRANCACARTAO') {
        return this.form.colunaCobrancaCartao.value
      }
      if (tipoPlanilha === 'COBRANCAGERAIS') {
        return this.form.colunaCobrancaGerais.value
      }
      if (tipoPlanilha === 'AJUIZAMENTO') {
        return this.form.colunaAjuizamento.value
      }

      if (
        tipoPlanilha === 'CARDCOOPERADO' ||
        tipoPlanilha === 'CARDNAOCOOPERADO'
      ) {
        return this.form.columnImportCards.value
      }

      return null
    },
    addFiles () {
      this.$refs.planilhas.click()
    },
    handleFilesUpload () {
      const files = this.$refs.planilhas.files
      for (const index in files) {
        if (files[index].size > 0) {
          this.files.push(files[index])
        }
      }
    },
    onDragOver (event) {
      event.preventDefault()
      // Set the dropEffect to move
      event.dataTransfer.dropEffect = 'move'
    },
    onDrop (event) {
      const files = event.dataTransfer.files
      for (const index in files) {
        if (files[index].size > 0) {
          this.files.push(files[index])
        }
      }
    },
    bytesToSize (bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return '0 Byte'
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
    },
    async onLoadOrigem () {
      try {
        loading.push(true)
        const response = await OriginRepository.GetAll()
        const options = response.data.content
          .sort((a, b) => a.nome - b.nome)
          .filter((x) => x.id != null)
          .map((x) => ({ value: x.id, text: x.nome }))

        this.form.origemImportCards.options = options
      } catch (error) {
        this.onExceptio(error)
      } finally {
        loading.pop()
      }
    },
    async onLoadBoardsCobranca () {
      try {
        loading.push()
        const response = await BoardRepository.GetAllTipoBoard('COBRANCA')
        const options = response.data.content
          .filter(
            (x) => x.id != null && x.arquivado !== true && x.isReadOnly !== true
          )
          .map((x) => ({ value: x.id, text: x.nome }))

        this.form.tipoBoardCobrancaEmprestimo.options = options
        this.form.tipoBoardCobrancaCartao.options = options
        this.form.tipoBoardCobrancaGerais.options = options
      } catch (error) {
        this.onExceptio(error)
      } finally {
        loading.pop()
      }
    },
    async onLoadBoardsAjuizamento () {
      try {
        loading.push()
        const response = await BoardRepository.GetAllTipoBoard('AJUIZAMENTO')
        const options = response.data.content
          .filter(
            (x) => x.id != null && x.arquivado !== true && x.isReadOnly !== true
          )
          .map((x) => ({ value: x.id, text: x.nome }))

        this.form.tipoBoardAjuizamento.options = options
      } catch (error) {
        this.onExceptio(error)
      } finally {
        loading.pop()
      }
    },
    async onLoadBoards () {
      try {
        loading.push()
        const response = await BoardRepository.GetAllActive()
        const options = response.data.content
          .filter(
            (x) => x.id != null && x.arquivado !== true && x.isReadOnly !== true
          )
          .map((x) => ({ value: x.id, text: x.nome }))

        this.form.boardImportCards.options = options
      } catch (error) {
        this.onExceptio(error)
      } finally {
        loading.pop()
      }
    },
    async onLoadColumns (field, boardId) {
      if (!boardId) {
        field.options = []
        return
      }

      try {
        loading.push()
        const response = await BoardColumnRepository.SearchActive(boardId)
        field.options = response.data.content
          .filter((x) => x.id != null && x.inative !== true)
          .map((x) => {
            return x.eventoColuna === 1
              ? { value: x.id, text: x.nome, disabled: true }
              : { value: x.id, text: x.nome }
          })
      } catch (error) {
        this.onExceptio(error)
      } finally {
        loading.pop()
      }
    },
    changeTipoPlanilha (tipo) {
      const fields = [
        'tipoBoardCobrancaEmprestimo',
        'colunaCobrancaEmprestimo',
        'tipoBoardCobrancaCartao',
        'colunaCobrancaCartao',
        'tipoBoardCobrancaGerais',
        'colunaCobrancaGerais',
        'tipoBoardAjuizamento',
        'colunaAjuizamento',
        'origemImportCards',
        'boardImportCards',
        'columnImportCards'
      ]

      for (const field of fields) {
        this.form[field].value = null
      }
    }
  }
}
</script>

<style scoped>
.block-upload {
  border: dashed 1px #ccc;
  border-radius: 5px;
  background-color: #f8f9fa;
  cursor: pointer;
}

.block-upload:hover {
  font-weight: bold;
  /*
  -webkit-transform: scale(1.2);
  -ms-transform: scale(1.2);
  transform: scale(1.2);
  transition: 1s ease;
  */
}

li {
  list-style-type: none;
}

li div {
  cursor: pointer;
  width: auto;
  display: initial;
}

.excel-color {
  color: #019727;
  padding-top: 10px;
}

.upload {
  height: 300%;
  width: 100%;
  opacity: 0.9;
  text-align: center;
  background: #efefef;
  display: block;
  position: absolute;
  z-index: 9;
  overflow: hidden;
  top: 0;
  left: 0;
}

.uploadText h2 {
  width: 100%;
  text-align: center;
  margin-top: 20%;
  display: block;
  position: absolute;
  z-index: 99999;
  top: 0;
  left: 0;
}

.uploadText h2 i {
  color: #04a791;
}

.upload-loading {
  display: block;
  position: absolute;
  z-index: 99999;
  top: 45%;
  left: 45%;
}

.upload-loading-img {
  margin: auto;
  display: block;
  opacity: 0.9;
}
</style>



// WEBPACK FOOTER //
// src/views/private/import/components/add/importadd.vue